var map = {
	"./1.jpg": 2162,
	"./10.jpg": 2163,
	"./2.jpg": 2164,
	"./3.jpg": 2165,
	"./4.jpg": 2166,
	"./5.jpg": 2167,
	"./6.jpg": 2168,
	"./7.jpg": 2169,
	"./8.jpg": 2170,
	"./9.jpg": 2171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2161;